import React from 'react'
import { SettingsControlTile } from '../common'
import StyledSwitch from '@e3dc-react/shell/Elements/Switch/StyledSwitch'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useFormContext, useWatch } from 'react-hook-form'
import { Ai360SettingsFormValues } from '../../types'
import { TariffsModeModel } from '../../model'

interface Props {
  tariffsMode: TariffsModeModel | null
}

/**
 * component to activate/deactivate SG-Ready feature
 */
const SGReadySettingsControlTile: React.FC<Props> = ({ tariffsMode }) => {
  const { t } = useCustomTranslation()
  const { control, setValue } = useFormContext<Ai360SettingsFormValues>()
  const isAI360Active = useWatch({ control, name: 'isAI360Active' })
  const isSGReadyActive = useWatch({ control, name: 'isSGReadyActive' })
  const isChargingFromGridActive = useWatch({ control, name: 'isChargingFromGridActive' })

  const handleToggle = (): void => {
    setValue('isSGReadyActive', !isSGReadyActive, { shouldDirty: true })
  }

  const suffix = (
    <StyledSwitch
      checked={isSGReadyActive}
      onChange={handleToggle}
      disabled={!isAI360Active || !isChargingFromGridActive || tariffsMode?.mode === 'STATIC'}
    />
  )

  return <SettingsControlTile title={t('ai360.settings-page.activate-sg-ready')} suffix={suffix} />
}

export default SGReadySettingsControlTile
